goog.provide("shadow.js.shim.module$pdfjs_dist$build$pdf");
goog.provide("module$shadow_js_shim_module$pdfjs_dist$build$pdf");
shadow.js.shim.module$pdfjs_dist$build$pdf = shadow.js.nativeProvides["pdfjs-dist/build/pdf"] = shadow$bridge("pdfjs-dist/build/pdf");
module$shadow_js_shim_module$pdfjs_dist$build$pdf.default = shadow.js.shim.module$pdfjs_dist$build$pdf;
